import { useState } from 'react'
import { Modal, ModalCloseButton } from '../Modal.js'
import { Button, Field, Textarea } from '../ui.js'

/**
 * A note is written in a window, the same way an email and a text are. It is
 * opened from the card's header; the activity column only reads notes.
 */
export function NoteCompose({
  open,
  onClose,
  isAddingNote,
  onAddNote,
}: {
  open: boolean
  onClose: () => void
  isAddingNote: boolean
  onAddNote: (body: string, done: () => void) => void
}) {
  if (!open) return null
  return (
    <NoteForm isAddingNote={isAddingNote} onAddNote={onAddNote} onClose={onClose} />
  )
}

function NoteForm({
  isAddingNote,
  onAddNote,
  onClose,
}: {
  isAddingNote: boolean
  onAddNote: (body: string, done: () => void) => void
  onClose: () => void
}) {
  const [draft, setDraft] = useState('')

  return (
    <Modal open onClose={onClose} labelledBy="note-compose-title" className="max-w-[480px]">
      <div className="flex items-center gap-3 border-b border-ink-200 px-4 py-3">
        <h2 id="note-compose-title" className="text-base font-semibold text-ink-900">
          New note
        </h2>
        <div className="ml-auto">
          <ModalCloseButton onClose={onClose} />
        </div>
      </div>
      <div className="p-4">
        <Field label="Note" htmlFor="note-compose-body">
          <Textarea
            id="note-compose-body"
            aria-label="New note"
            rows={5}
            value={draft}
            placeholder="Write a note. The technician sees it on the phone."
            onChange={(event) => setDraft(event.target.value)}
          />
        </Field>
      </div>
      <div className="flex items-center justify-end gap-2 border-t border-ink-200 px-4 py-3">
        <Button size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button
          size="sm"
          variant="primary"
          loading={isAddingNote}
          disabled={draft.trim().length === 0}
          onClick={() => onAddNote(draft.trim(), () => {
            setDraft('')
            onClose()
          })}
        >
          Add the note
        </Button>
      </div>
    </Modal>
  )
}
